export type TOverwriteAccessorsFunction = (
    object: object,
    property: string,
    createGetter: (get: Required<PropertyDescriptor>['get']) => Required<PropertyDescriptor>['get'],
    createSetter: (get: Required<PropertyDescriptor>['set']) => Required<PropertyDescriptor>['set']
) => void;
